"use strict";
exports.__esModule = true;
var react_1 = require("react");
var endPoint = "/present_search/situation_selector.json";
// API経由で選択肢を取得するフック
function useFetchSituationOptions(currentState, selectedPresenteeId, selectedAgeId, selectedOccasionId) {
    var _a = react_1.useState(null), situationOptions = _a[0], setSituationOptions = _a[1];
    var _b = react_1.useState(false), success = _b[0], setSuccess = _b[1];
    var _c = react_1.useState(null), error = _c[0], setError = _c[1];
    react_1.useEffect(function () {
        setSuccess(false);
        setError(null);
        var searchParams = new URLSearchParams();
        if (selectedPresenteeId !== "") {
            searchParams.append("presentee", selectedPresenteeId);
        }
        if (selectedAgeId !== "") {
            searchParams.append("age", selectedAgeId);
        }
        if (selectedOccasionId !== "") {
            searchParams.append("occasion", selectedOccasionId);
        }
        fetch(endPoint + "?" + searchParams.toString(), {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        })
            .then(function (res) { return res.json(); })
            .then(function (res) {
            var result = {
                presenteeOptions: res.presentee_selector,
                ageOptions: res.age_selector,
                occasionOptions: res.occasion_selector
            };
            setSituationOptions(result);
            setSuccess(true);
        })["catch"](function (e) {
            setError(e);
        });
    }, [currentState, selectedPresenteeId, selectedAgeId, selectedOccasionId]);
    return [situationOptions, success, error];
}
exports.useFetchSituationOptions = useFetchSituationOptions;
